module.exports = __webpack_public_path__ + "static/media/proj4_img9.9a37b2ff.jpg";